import $ from 'jquery';

const $document = $(document);

$(function () {
    $document.on('click', '.modal-trigger', function () {
        const $targetModal = $($(this).data('target'));
        openModal($targetModal);
    });
    $document.on('click', '.modal', function () {
        closeModal($(this));
    });
    $document.on('click', '.modal__close,.modal-close', function () {
        const $targetModal = $(this).closest('.modal');
        closeModal($targetModal);
    });
    $document.on('keydown', function (event) {
        const $targetModal = $document.find('.modal.active');
        if (event.key === 'Escape') {
            closeModal($targetModal);
        }
    });
    $document.on('click', '.modal__content > *', function (event) {
        event.stopImmediatePropagation();
    });
});

export function openModal(targetModal) {
    if (targetModal !== undefined) {
        if (!targetModal.hasClass('active')) {
            targetModal.trigger('modal:opening');
            targetModal.addClass('active').one('transitionend', function () {
                targetModal.trigger('modal:opened');
            });
        }
    }
}

export function closeModal(targetModal) {
    if (targetModal !== undefined) {
        if (targetModal.hasClass('active')) {
            targetModal.trigger('modal:closing');
            targetModal.removeClass('active').one('transitionend', function () {
                targetModal.trigger('modal:closed');
            });
        }
    }
}
